var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"text-center",attrs:{"justify-center":"","pa-0":""}},[_c('h3',[_vm._v(_vm._s(_vm.$t("message.not_active")))]),_c('icon-master',{staticClass:"rotate",attrs:{"size":"400px","color":"error"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }